import {DAILY_INCOME,RECENT_TRANSACTION,SHOW_TODAY_INCOME,TODAYINCOME_TABLE,ALL_TRANSACTION} from '../actionTypes/PaymentActionsType';
const initialState={
    dailyIncome:0,
    monthlyIncome:0,
    yearlyIncome:0,
    year:0 ,
    recentPayments: [],
    showTable:false,
    todayIncome:[],
    allTransaction: [],
}
export const PaymentReducer=(state=initialState,action)=>{
    switch(action.type){
        case DAILY_INCOME:return {...state,dailyIncome:action.payload}
        case RECENT_TRANSACTION:return {...state,recentPayments:action.payload}
        case SHOW_TODAY_INCOME:return {...state, showTable:!state.showTable}
        case TODAYINCOME_TABLE:return{...state,todayIncome:action.payload}

       
        case ALL_TRANSACTION:
        const t = [...state.allTransaction,...action.payload];      
  console.log(t)
        return {
          ...state,allTransaction: t,
        };
      default: 
    return state;
    }
}